<div class="list" [class.error]="error" #list>
  <ng-content></ng-content>
</div>
@if (addMoreVisible) {
  <button
    vinnova-button-secondary
    type="button"
    class="add-button"
    (click)="onAddMore($event)"
    (keydown.tab)="buttonBlurred()"
  >
    {{ addMoreText }}
  </button>
}
